export default {
	// apiUrlBase: 'https://app.restorani.bitlab.host',
	apiUrlBase: 'https://app2.ordera.app',
	// apiUrl: 'https://app.restorani.bitlab.host/api'
	apiUrl: 'https://app2.ordera.app/api'
}